<div class="widget">
  <i *ngIf="icon" class="fas" [class]="icon"></i>
  <span>{{message}}</span>
  <app-button [text]="buttonText" [style]="'outlined'" [leftIcon]="'fas fa-plus'" (clickEvent)="handleButtonClick()"></app-button>
</div>
